import { toRefs, computed } from 'vue';
import ProfileLinkWrapper from '../component-lib.esm4.js';
import { useLink } from '../component-lib.esm6.js';
import { LINK_PROPS } from '../component-lib.esm3.js';
import Typeform from './sources/component-lib.esm.js';
import Jotform from './sources/component-lib.esm2.js';

//
var script = {
  components: {
    ProfileLinkWrapper,
    Typeform,
    Jotform
  },
  props: LINK_PROPS,
  setup(props, context) {
    const {
      link
    } = toRefs(props);
    const {
      id,
      imageUrl,
      btnProps
    } = useLink(props, context);
    const formOptions = computed(() => {
      return link.value.form_options;
    });
    const linkComponent = computed(() => {
      switch (formOptions.value.source) {
        case 'typeform':
          return 'Typeform';
        case 'jotform':
          return 'Jotform';
      }
      return null;
    });
    const classes = computed(() => {
      return {
        'v-form--remove-bg': formOptions.value.remove_bg
      };
    });
    return {
      id,
      formOptions,
      classes,
      imageUrl,
      linkComponent,
      btnProps
    };
  }
};
export { script as default };